<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">

    <div class="spacer2"></div>

    <div class="containter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Payments
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          A subscription allows users to access premium features, services, or content by paying on a recurring basis—usually monthly or annually.
        </div>
      </div>

      <div class="spacer2"></div>

        <div class="ptitle">Free Trial</div>
        <!-- <div class="ptitle" >Pro</div> -->
        <div class="stitle">Credit balance</div>
        <div class="balval credits">   <img src="assets/images/credits.svg"  class="h-25" >  <span style="font-size: 14px; margin-left: 5px;"></span></div>
        <div style="padding-bottom: 0px;">These credits cover approximately  document reviews, each around 20,000 words.</div>
        <!-- <div style="padding-bottom: 10px;">Your monthly plan will reset on , at which point 3,000 ($50) worth of new credits will be added to your account.</div> -->
         <div class="spacer-1"></div>
        <button
          mat-raised-button
          color="primary"        
          class="btn-send clr-white" (click)="topUP('payment')"     
        >Purchase Credits
        </button>
        <!-- (click)="upgrade()" -->
        <button style="margin-left: 10px;" 
          mat-raised-button
          color="primary"        
          class="btn-send clr-white" 
        >Upgrade to Pro
        </button>


</div>

</div>
</div>
</div>